var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CourseList',{attrs:{"level-key":"upperIntermediateLevel","fetch-action":"getCourseUpperIntermediates","getter-name":"courseUpperIntermediates"}})
}
var staticRenderFns = []

export { render, staticRenderFns }